import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class AboutV4 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

    return <section className="about-four  go-top">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-6">
		        <div className="about-four__content">
		          <div className="block-title-two text-left">
		            <h3>Perfect application for your business</h3>
		          </div>{/* /.block-title-two text-left */}
		          <p>  Converzex empowers businesses with intelligent conversational and voice solutions designed to enhance customer engagement, accelerate lead qualification, and drive conversions, without compromising the natural, human-centered experience. </p>
		          <div className="about-four__box-wrap">
		            <div className="about-four__box">
		              <div className="about-four__box-icon">
		                <i className="fal fa-atom-alt" />
		              </div>{/* /.about-four__box-icon */}
		              <div className="about-four__box-content">
		                <h3>Conversational AI Assistant</h3>
		                <p>Understands user intent and collects qualified leads.</p>
		              </div>{/* /.about-four__box-content */}
		            </div>{/* /.about-four__box */}

					  <div className="about-four__box">
		              <div className="about-four__box-icon">
		                <i className="fal fa-clock" />
		              </div>{/* /.about-four__box-icon */}
		              <div className="about-four__box-content">
		                <h3>Voice-Enabled Bot</h3>
		                <p>Handles real-time voice calls powered by natural AI voices.</p>
		              </div>{/* /.about-four__box-content */}
		            </div>{/* /.about-four__box */}

					  <div className="about-four__box">
		              <div className="about-four__box-icon">
		                <i className="fal fa-atom-alt" />
		              </div>{/* /.about-four__box-icon */}
		              <div className="about-four__box-content">
		                <h3>Intelligent Lead Routing</h3>
		                <p>Sends qualified leads directly to your company portal or CRM</p>
		              </div>{/* /.about-four__box-content */}
		            </div>{/* /.about-four__box */}

					  <div className="about-four__box">
						  <div className="about-four__box-icon">
							  <i className="fal fa-clock" />
						  </div>{/* /.about-four__box-icon */}
						  <div className="about-four__box-content">
							  <h3>Easy Integration</h3>
							  <p>Add to your website with just a few lines of code.</p>
						  </div>{/* /.about-four__box-content */}
					  </div>{/* /.about-four__box */}

					  <div className="about-four__box">
						  <div className="about-four__box-icon">
							  <i className="fal fa-lock" />
						  </div>{/* /.about-four__box-icon */}
						  <div className="about-four__box-content">
							  <h3>Secure & Scalable</h3>
							  <p>Built with enterprise-grade privacy and uptime reliability.</p>
						  </div>{/* /.about-four__box-content */}
					  </div>{/* /.about-four__box */}
		          </div>{/* /.about-four__box-wrap */}
		        </div>{/* /.about-four__content */}
		      </div>{/* /.col-lg-6 */}
		      <div className="col-lg-6">
		        <img src={publicUrl+"assets/images/resources/work-img-1.png"} className="about-four__moc" alt={ imagealt } />
		      </div>{/* /.col-lg-6 */}
		    </div>{/* /.row */}
		  </div>{/* /.container */}
		</section>

        }
}

export default AboutV4